import { render, staticRenderFns } from "./AdminLicenseApproveModal.vue?vue&type=template&id=23ffbe46"
import script from "./AdminLicenseApproveModal.vue?vue&type=script&lang=js"
export * from "./AdminLicenseApproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ffbe46')) {
      api.createRecord('23ffbe46', component.options)
    } else {
      api.reload('23ffbe46', component.options)
    }
    module.hot.accept("./AdminLicenseApproveModal.vue?vue&type=template&id=23ffbe46", function () {
      api.rerender('23ffbe46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminLicenseApproveModal.vue"
export default component.exports